(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationCampaignFormController', CommunicationCampaignFormController);

    CommunicationCampaignFormController.$inject = ['$scope', '$state', '$filter', '$window', '$timeout', '$sce', 'AlertService', 'entity', 'CommunicationCampaign',
        'ChannelConf', 'Agence', 'PortefeuilleContrat', 'ContractType', 'ContractProfil', 'ServiceVendu', 'CommunicationTopic',
        'CommunicationTopicCategory', 'Principal', 'AssistantPanelService', '$translate'];

    function CommunicationCampaignFormController($scope, $state, $filter, $window, $timeout, $sce, AlertService, entity, CommunicationCampaign, ChannelConf,
        Agence, PortefeuilleContrat, ContractType, ContractProfil, ServiceVendu, CommunicationTopic, CommunicationTopicCategory,
        Principal, AssistantPanelService, $translate) {
        var FILTERS_MARKER = '[CAMPAIGN_FILTERS_JSON]';
        var LIVE_PREVIEW_DELAY_MS = 500;
        var livePreviewPromise;
        var livePreviewRequestId = 0;
        var vm = this;
        vm.communicationCampaign = entity;
        vm.isEdit = !!vm.communicationCampaign.id;
        vm.isLocked = !!vm.communicationCampaign.sendingDone;
        vm.canUseAssistant = false;
        vm.channels = [];
        vm.agences = Agence.currentOrganisation();
        vm.datePickerOpenStatus = { desiredSendDate: false };
        vm.date = { startDate: null, endDate: null };
        vm.searchContracts = searchContracts;
        vm.download = download;
        vm.previewMessage = previewMessage;
        vm.save = save;
        vm.back = back;
        vm.isEmailChannel = isEmailChannel;
        vm.showTemplateHelp = false;
        vm.internalCommentNote = '';
        vm.savedFilters = null;
        vm.savedFiltersJson = '';
        vm.savedFiltersSummary = [];
        vm.livePreview = buildEmptyLivePreview();
        vm.templateVariables = [
            '${contractRef}',
            '${contractName}',
            '${contractAddress}',
            '${amountBilled}',
            '${totalToBePaid}',
            '${servicesToBePaid}',
            '${taxesToBePaid}',
            '${servicesToBePaidHtml}',
            '${taxesToBePaidHtml}',
            '${dateNow}'
        ];
        vm.openCalendar = function(date) { vm.datePickerOpenStatus[date] = true; };
        vm.toggleTemplateHelp = function() { vm.showTemplateHelp = !vm.showTemplateHelp; };
        vm.openAssistantChat = openAssistantChat;

        vm.portefeuilleContrats = PortefeuilleContrat.query({ offset: 0, size: 1000, sort: 'libelle,asc' });
        vm.contractTypes = ContractType.query({ offset: 0, size: 1000, sort: 'label,asc' });
        vm.contractProfils = ContractProfil.query({ offset: 0, size: 1000, sort: 'libelle,asc' });
        vm.serviceVendus = ServiceVendu.queryInclDeleted({ offset: 0, size: 1000, sort: 'libelle,asc' });
        vm.communicationTopics = CommunicationTopic.byAgence({ agenceId: -1 });
        vm.communicationTopicCategories = CommunicationTopicCategory.queryInclDeleted({ offset: 0, size: 1000, sort: 'label,asc' });
        vm.agenceNotPromise = [];
        vm.portefeuilleContratNotPromise = [];
        vm.contractTypeNotPromise = [];
        vm.contractProfilNotPromise = [];
        vm.serviceVenduNotPromise = [];
        vm.communicationTopicNotPromise = [];
        vm.communicationTopicCategoryNotPromise = [];

        parseStoredComment();

        if (!vm.communicationCampaign.agenceIds) {
            vm.communicationCampaign.agenceIds = [];
        }
        vm.contractSearchResult = {
            contractCount: vm.communicationCampaign.contratCount || 0,
            contratIds: angular.copy(vm.communicationCampaign.contratIds)
        };

        if (vm.isEdit && vm.communicationCampaign.agenceIds.length && vm.agences.$promise) {
            vm.agences.$promise.then(function(result) {
                vm.agenceNotPromise = result.filter(function(agence) {
                    return vm.communicationCampaign.agenceIds.indexOf(agence.id) >= 0;
                });
            });
        }

        loadChannels();
        Principal.identity().then(function(account) {
            if (account) {
                vm.canUseAssistant = (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                    && (account.authorities.indexOf('ROLE_AI_ASSISTANT') !== -1
                    || account.authorities.indexOf('ROLE_ADMIN') !== -1
                    || account.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1);
            }
        });
        registerPreviewWatchers();
        scheduleLivePreview();

        function buildSearchParams() {
            return {
             //   nom: vm.searchQuery,
                compteurFerme: vm.compteurFerme,
                agence: collectIds(vm.agenceNotPromise),
                portefeuilleContrat: collectIds(vm.portefeuilleContratNotPromise || vm.portefeuilleContrat),
                contractType: collectIds(vm.contractTypeNotPromise || vm.contractType),
                contractProfil: collectIds(vm.contractProfilNotPromise || vm.contractProfil),
                serviceVendu: collectIds(vm.serviceVenduNotPromise || vm.serviceVendu),
                communicationTopic: collectIds(vm.communicationTopicNotPromise || vm.communicationTopic),
                communicationTopicCategory: collectIds(vm.communicationTopicCategoryNotPromise || vm.communicationTopicCategory),
                etat: vm.etat,
                fromDate: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(vm.date.endDate, 'yyyy-MM-dd'),
                hasEmail: vm.hasEmail,
                hasPhone: vm.hasPhone
				//,
        //        onlinePaymentType: vm.onlinePaymentType,
        //        onlinePaymentQuery: vm.onlinePaymentQuery,
        //        onlinePaymentActive: vm.onlinePaymentActive
            };
        }

        function collectIds(values) {
            return values && values.length ? values.map(function(elem) { return elem.id; }).join(',') : null;
        }

        function loadChannels() {
            ChannelConf.query({ page: 0, size: 1000, sort: 'nom,asc' }).$promise.then(function(result) {
                vm.channels = extractDistinctChannels(result || []);
                if (!vm.channels.length) {
                    loadChannelEnumFallback();
                }
            }, function() {
                loadChannelEnumFallback();
            });
        }

        function loadChannelEnumFallback() {
            CommunicationCampaign.getChannel().$promise.then(function(result) {
                vm.channels = result || [];
            }, function() {
                vm.channels = [];
            });
        }

        function extractDistinctChannels(channelConfs) {
            var map = {};
            angular.forEach(channelConfs, function(channelConf) {
                if (channelConf && channelConf.channel && !map[channelConf.channel]) {
                    map[channelConf.channel] = {
                        name: channelConf.channel,
                        label: channelConf.nom ? channelConf.nom + ' (' + channelConf.channel + ')' : channelConf.channel
                    };
                }
            });
            return Object.keys(map).map(function(key) {
                return map[key];
            });
        }

        function searchContracts() {
            CommunicationCampaign.searchContracts(buildSearchParams()).$promise.then(function(result) {
                vm.contractSearchResult = result;
                vm.communicationCampaign.contratIds = angular.copy(result.contratIds || []);
                updateSavedFilters(buildCampaignFiltersSnapshot(result));
                scheduleLivePreview();
            }, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function download() {
            var action = vm.isEdit ? CommunicationCampaign.downloadCampaigncsv : CommunicationCampaign.downloadcsv;
            var params = vm.isEdit ? { id: vm.communicationCampaign.id } : buildSearchParams();
            action(params, function(content) {
                var url = URL.createObjectURL(content.response);
                var a = document.createElement('a');
                a.href = url;
                a.download = content.fileName;
                a.target = '_blank';
                a.click();
            });
        }

        function previewMessage() {
            CommunicationCampaign.preview(buildCampaignPreviewPayload()).$promise.then(function(preview) {
                if (preview.subject) {
                    openInNewWindow('<html><head><title>Subject preview</title></head><body><h2>Subject :</h2> ' + preview.subject + ' <hr/></body></html>');
                }
                if (preview.messageHtml) {
                    openInNewWindow(preview.messageHtml);
                }
                if (preview.messageText) {
                    openInNewWindow('<html><head><title>Preview</title></head><body><textarea rows="10" cols="80">' + preview.messageText + '</textarea></body></html>');
                }
            });
        }

        function openInNewWindow(content) {
            var newWindow = $window.open('', '_blank');
            newWindow.document.open();
            newWindow.document.write(content);
            newWindow.document.close();
        }

        function save() {
            if (vm.isLocked) {
                AlertService.error('Cette campagne a déjà été envoyée et ne peut plus être modifiée.');
                return;
            }
            if (vm.communicationCampaign.desiredSendDate && !isDesiredSendDateInFuture(vm.communicationCampaign.desiredSendDate)) {
                AlertService.error('La date d\'envoi doit être dans le futur.');
                return;
            }
            vm.isSaving = true;
            if (!vm.communicationCampaign.desiredSendDate) {
                vm.communicationCampaign.desiredSendDate = null;
            }
            vm.communicationCampaign.contratCount = vm.isEdit ? (vm.communicationCampaign.contratCount || 0) : (vm.communicationCampaign.contratIds ? vm.communicationCampaign.contratIds.length : 0);
            vm.communicationCampaign.agenceIds = vm.agenceNotPromise ? vm.agenceNotPromise.map(function(agence) { return agence.id; }) : [];
            updateSavedFilters(buildFiltersSnapshotForSave());
            vm.communicationCampaign.internalComment = composeStoredInternalComment(vm.internalCommentNote, vm.savedFilters);
            if (vm.isEdit) {
                vm.communicationCampaign.contratIds = null;
            }
            if (vm.communicationCampaign.id !== null) {
                CommunicationCampaign.update(vm.communicationCampaign, onSaveSuccess, onSaveError);
            } else {
                CommunicationCampaign.save(vm.communicationCampaign, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            $state.go('communication-campaign', null, { reload: true });
        }

        function onSaveError(error) {
            vm.isSaving = false;
            if (error && error.data && error.data.message) {
                AlertService.error(error.data.message);
            } else {
                AlertService.error('Impossible d\'enregistrer la campagne.');
            }
        }

        function back() {
            $state.go('communication-campaign');
        }

        function isEmailChannel() {
            return vm.communicationCampaign.channel === 'EMAIL_SENDBLUE' || vm.communicationCampaign.channel === 'EMAIL_SMTP';
        }

        function isDesiredSendDateInFuture(desiredSendDate) {
            return new Date(desiredSendDate).getTime() > new Date().getTime();
        }

        function openAssistantChat() {
            if (!vm.canUseAssistant || vm.isLocked) {
                return;
            }

            AssistantPanelService.open({
                contextType: 'COMMUNICATION_CAMPAIGN',
                entityId: vm.communicationCampaign.id || -1,
                title: $translate.instant('global.assistant.templateTitle'),
                subtitle: vm.communicationCampaign.title || 'Communication campaign',
                promptPlaceholder: $translate.instant('global.assistant.templatePromptPlaceholder'),
                supportsActionProposal: false,
                supportsDataScopes: false,
                adapter: {
                    chat: function(payload, success, error) {
                        CommunicationCampaign.chatAssistant(buildAssistantRequest(payload), success, error);
                    },
                    getUsage: function(success, error) {
                        CommunicationCampaign.getAssistantUsage(success, error);
                    },
                    submitFeedback: function(payload, success, error) {
                        CommunicationCampaign.submitAssistantFeedback(payload, success, error);
                    },
                    applyAssistantResponse: function(result) {
                        if (!result || !result.suggestedFieldValues) {
                            return;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template) && result.suggestedFieldValues.template !== null) {
                            vm.communicationCampaign.templateTxt = result.suggestedFieldValues.template;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_html) && result.suggestedFieldValues.template_html !== null) {
                            vm.communicationCampaign.templateHtml = result.suggestedFieldValues.template_html;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_subject) && result.suggestedFieldValues.template_subject !== null) {
                            vm.communicationCampaign.templateSubject = result.suggestedFieldValues.template_subject;
                        }
                        AssistantPanelService.invalidateConversationContext();
                        $scope.$evalAsync();
                    },
                    buildContextSignatureFragment: function() {
                        return [
                            vm.communicationCampaign.channel || '',
                            vm.communicationCampaign.title || '',
                            hashString(vm.internalCommentNote || ''),
                            hashString(vm.communicationCampaign.templateTxt || ''),
                            hashString(vm.communicationCampaign.templateHtml || ''),
                            hashString(vm.communicationCampaign.templateSubject || '')
                        ].join('|');
                    }
                }
            });
        }

        function buildAssistantRequest(payload) {
            return {
                assistantRequest: payload,
                communicationAutomationConf: {
                    id: vm.communicationCampaign.id,
                    type: 'COMMUNICATION_CAMPAIGN',
                    template: vm.communicationCampaign.templateTxt,
                    templateHtml: vm.communicationCampaign.templateHtml,
                    templateSubject: vm.communicationCampaign.templateSubject
                },
                availableVariables: angular.copy(vm.templateVariables),
                selectedChannel: vm.communicationCampaign.channel,
                contextType: 'COMMUNICATION_CAMPAIGN',
                contextEntityId: vm.communicationCampaign.id || null,
                contextLabel: vm.communicationCampaign.title || 'Communication campaign',
                contextMetadata: {
                    title: vm.communicationCampaign.title,
                    internalComment: vm.internalCommentNote,
                    desiredSendDate: vm.communicationCampaign.desiredSendDate,
                    contratCount: vm.isEdit ? vm.communicationCampaign.contratCount : (vm.communicationCampaign.contratIds || []).length
                }
            };
        }

        function registerPreviewWatchers() {
            $scope.$watchGroup([
                function() { return vm.communicationCampaign.channel; },
                function() { return vm.communicationCampaign.templateTxt; },
                function() { return vm.communicationCampaign.templateHtml; },
                function() { return vm.communicationCampaign.templateSubject; },
                function() { return (vm.communicationCampaign.contratIds || []).join(','); }
            ], function() {
                scheduleLivePreview();
            });

            $scope.$on('$destroy', function() {
                if (livePreviewPromise) {
                    $timeout.cancel(livePreviewPromise);
                }
            });
        }

        function scheduleLivePreview() {
            if (livePreviewPromise) {
                $timeout.cancel(livePreviewPromise);
            }
            if (!hasTemplateContent()) {
                vm.livePreview = buildEmptyLivePreview();
                return;
            }
            vm.livePreview.isLoading = true;
            livePreviewPromise = $timeout(refreshLivePreview, LIVE_PREVIEW_DELAY_MS);
        }

        function refreshLivePreview() {
            var requestId = ++livePreviewRequestId;
            CommunicationCampaign.preview(buildCampaignPreviewPayload()).$promise.then(function(preview) {
                if (requestId !== livePreviewRequestId) {
                    return;
                }
                vm.livePreview = {
                    isLoading: false,
                    hasContent: !!(preview && (preview.subject || preview.messageText || preview.messageHtml)),
                    error: null,
                    subject: preview && preview.subject ? preview.subject : '',
                    messageText: preview && preview.messageText ? preview.messageText : '',
                    messageHtml: preview && preview.messageHtml ? preview.messageHtml : '',
                    trustedMessageHtml: $sce.trustAsHtml(preview && preview.messageHtml ? preview.messageHtml : '')
                };
            }, function(response) {
                if (requestId !== livePreviewRequestId) {
                    return;
                }
                vm.livePreview = {
                    isLoading: false,
                    hasContent: false,
                    error: $translate.instant(response && response.data && response.data.message === 'error.unsafeTemplateHtml'
                        ? 'error.unsafeTemplateHtml' : 'wamasysApp.communicationCampaign.livePreviewError'),
                    subject: '',
                    messageText: '',
                    messageHtml: '',
                    trustedMessageHtml: $sce.trustAsHtml('')
                };
            });
        }

        function buildCampaignPreviewPayload() {
            var payload = angular.copy(vm.communicationCampaign);
            payload.internalComment = vm.internalCommentNote;
            return payload;
        }

        function buildEmptyLivePreview() {
            return {
                isLoading: false,
                hasContent: false,
                error: null,
                subject: '',
                messageText: '',
                messageHtml: '',
                trustedMessageHtml: $sce.trustAsHtml('')
            };
        }

        function hasTemplateContent() {
            return !!(vm.communicationCampaign.templateTxt || vm.communicationCampaign.templateHtml || vm.communicationCampaign.templateSubject);
        }

        function buildFiltersSnapshotForSave() {
            if (vm.isEdit && vm.savedFilters) {
                return vm.savedFilters;
            }
            return buildCampaignFiltersSnapshot(vm.contractSearchResult);
        }

        function buildCampaignFiltersSnapshot(searchResult) {
            var snapshot = {
                version: 1,
                contractCount: resolveContractCount(searchResult),
                filters: compactObject({
                    agence: buildSelectionSnapshot(vm.agenceNotPromise, 'nom'),
                    etat: emptyToNull(vm.etat),
                    compteurFerme: normalizeBoolean(vm.compteurFerme),
                    dateActivation: buildDateRangeSnapshot(),
                    hasEmail: normalizeBoolean(vm.hasEmail),
                    hasPhone: normalizeBoolean(vm.hasPhone),
                    portefeuilleContrat: buildSelectionSnapshot(vm.portefeuilleContratNotPromise, 'libelle'),
                    serviceVendu: buildSelectionSnapshot(vm.serviceVenduNotPromise, 'libelle'),
                    contractType: buildSelectionSnapshot(vm.contractTypeNotPromise, 'label'),
                    contractProfil: buildSelectionSnapshot(vm.contractProfilNotPromise, 'libelle'),
                    communicationTopic: buildSelectionSnapshot(vm.communicationTopicNotPromise, 'nomInterne'),
                    communicationTopicCategory: buildSelectionSnapshot(vm.communicationTopicCategoryNotPromise, 'label')
                })
            };
            if (!snapshot.filters) {
                snapshot.filters = {};
            }
            return snapshot;
        }

        function resolveContractCount(searchResult) {
            if (searchResult && angular.isDefined(searchResult.contractCount) && searchResult.contractCount !== null) {
                return searchResult.contractCount;
            }
            if (vm.communicationCampaign.contratCount) {
                return vm.communicationCampaign.contratCount;
            }
            return (vm.communicationCampaign.contratIds || []).length;
        }

        function buildSelectionSnapshot(values, labelField) {
            if (!values || !values.length) {
                return null;
            }
            return values.map(function(value) {
                return {
                    id: value.id,
                    label: value[labelField]
                };
            });
        }

        function buildDateRangeSnapshot() {
            var fromDate = $filter('date')(vm.date.startDate, 'yyyy-MM-dd');
            var toDate = $filter('date')(vm.date.endDate, 'yyyy-MM-dd');
            if (!fromDate && !toDate) {
                return null;
            }
            return {
                from: fromDate || null,
                to: toDate || null
            };
        }

        function normalizeBoolean(value) {
            if (value === '' || angular.isUndefined(value) || value === null) {
                return null;
            }
            return value === true || value === 'true';
        }

        function emptyToNull(value) {
            return value === '' || angular.isUndefined(value) ? null : value;
        }

        function compactObject(value) {
            var compacted = {};
            angular.forEach(value, function(entry, key) {
                if (angular.isArray(entry) && entry.length) {
                    compacted[key] = entry;
                    return;
                }
                if (angular.isObject(entry) && !angular.isArray(entry)) {
                    var nested = compactObject(entry);
                    if (nested) {
                        compacted[key] = nested;
                    }
                    return;
                }
                if (entry !== null && !angular.isUndefined(entry) && entry !== '') {
                    compacted[key] = entry;
                }
            });
            return Object.keys(compacted).length ? compacted : null;
        }

        function updateSavedFilters(filters) {
            vm.savedFilters = filters;
            vm.savedFiltersJson = filters ? angular.toJson(filters, true) : '';
            vm.savedFiltersSummary = buildSavedFiltersSummary(filters);
        }

        function buildSavedFiltersSummary(filters) {
            var summary = [];
            if (!filters) {
                return summary;
            }
            summary.push({
                label: 'Contrats',
                value: String(filters.contractCount || 0)
            });
            appendSummaryValue(summary, 'Zones', filters.filters && filters.filters.agence);
            appendSummaryValue(summary, 'Etat', filters.filters && filters.filters.etat);
            appendSummaryValue(summary, 'Compteur ferme', filters.filters && filters.filters.compteurFerme);
            appendSummaryValue(summary, 'Date activation', filters.filters && filters.filters.dateActivation);
            appendSummaryValue(summary, 'Email', filters.filters && filters.filters.hasEmail);
            appendSummaryValue(summary, 'Telephone', filters.filters && filters.filters.hasPhone);
            appendSummaryValue(summary, 'Portefeuilles', filters.filters && filters.filters.portefeuilleContrat);
            appendSummaryValue(summary, 'Services', filters.filters && filters.filters.serviceVendu);
            appendSummaryValue(summary, 'Types de contrat', filters.filters && filters.filters.contractType);
            appendSummaryValue(summary, 'Profils', filters.filters && filters.filters.contractProfil);
            appendSummaryValue(summary, 'Topics', filters.filters && filters.filters.communicationTopic);
            appendSummaryValue(summary, 'Categories', filters.filters && filters.filters.communicationTopicCategory);
            return summary;
        }

        function appendSummaryValue(summary, label, value) {
            var formatted = formatSummaryValue(value);
            if (!formatted) {
                return;
            }
            summary.push({
                label: label,
                value: formatted
            });
        }

        function formatSummaryValue(value) {
            if (angular.isArray(value)) {
                return value.map(function(item) {
                    return item.label || item.id;
                }).join(', ');
            }
            if (angular.isObject(value)) {
                if (angular.isDefined(value.from) || angular.isDefined(value.to)) {
                    return [value.from || '?', value.to || '?'].join(' -> ');
                }
                return angular.toJson(value);
            }
            if (value === true) {
                return 'Oui';
            }
            if (value === false) {
                return 'Non';
            }
            return value;
        }

        function parseStoredComment() {
            var parsed = parseStoredInternalComment(vm.communicationCampaign.internalComment);
            vm.internalCommentNote = parsed.note;
            updateSavedFilters(parsed.filters);
        }

        function parseStoredInternalComment(value) {
            var comment = value || '';
            var markerIndex = comment.indexOf(FILTERS_MARKER);
            var parsedFilters = null;
            var note = comment;

            if (markerIndex >= 0) {
                note = comment.substring(0, markerIndex).replace(/\s+$/, '');
                try {
                    parsedFilters = angular.fromJson(comment.substring(markerIndex + FILTERS_MARKER.length).trim());
                } catch (e) {
                    parsedFilters = null;
                }
            }

            return {
                note: note || '',
                filters: parsedFilters
            };
        }

        function composeStoredInternalComment(note, filters) {
            var parts = [];
            var trimmedNote = (note || '').replace(/\s+$/, '');
            if (trimmedNote) {
                parts.push(trimmedNote);
            }
            parts.push(FILTERS_MARKER + '\n' + angular.toJson(filters || { version: 1, contractCount: 0, filters: {} }, true));
            return parts.join('\n\n');
        }

        function hashString(value) {
            var stringValue = value || '';
            var hash = 0;
            var i;
            var chr;
            for (i = 0; i < stringValue.length; i++) {
                chr = stringValue.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0;
            }
            return hash;
        }
    }
})();
